/**
 * CPA PromoCode Edit Strategy
 *
 * CPA backend expects the full expanded payload with duplicate key formats
 * (camelCase + snake_case) and all relational IDs (goalEntryId, publisherId, linkId).
 */

export const buildEditParams = (state) => {
    const promoCodeValue = state.promocode.title || state.promoTitle || '';
    const descriptionValue = state.description || '';

    return {
        params: JSON.stringify(state.metaParams),
        id: state.promocode.id,
        promoCodeId: state.promocode.id,
        promo_code_id: state.promocode.id,
        promocode: promoCodeValue,
        promo_code: promoCodeValue,
        title: promoCodeValue,
        description: descriptionValue,
        comment: descriptionValue,
        goalEntryId: state.goalEntryId,
        goal_entry_id: state.goalEntryId,
        publisherId: state.publisherId,
        publisher_id: state.publisherId,
        linkId: state.linkId,
        link_id: state.linkId
    };
};

/**
 * Whether editable fields (promoTitle, description) should sync from props
 * when the modal is hidden. CPA does not sync when hidden.
 */
export const shouldSyncWhenHidden = false;
